var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEquipments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.096,
    height: 23.096,
    viewBox: "0 0 23.096 23.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EQUIPMENTS",
    transform: "translate(24.45 24.632) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M34.7,34.982l1.584,1.582a.769.769,0,0,0,.652.218,3.056,3.056,0,0,1,3.307,1.985l-1.193-.835a.77.77,0,0,0-.985.087L35.583,40.5a.77.77,0,0,0-.087.986l.834,1.19a3.052,3.052,0,0,1-1.987-3.3.769.769,0,0,0-.218-.653l-2.984-2.981a.77.77,0,0,0-1.088,1.089l2.727,2.725a4.593,4.593,0,0,0,5.237,4.8.77.77,0,0,0,.523-1.2l-1.411-2.015L38.7,39.564l2.017,1.41a.77.77,0,0,0,1.2-.523,4.592,4.592,0,0,0-4.8-5.233l-1.328-1.326A.77.77,0,1,0,34.7,34.982Z",
    transform: "translate(-17.513 -19.763)",
    fill: "#0000b5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M10.292,12.642,3.347,5.7a1.546,1.546,0,0,1,0-2.188h0a1.5,1.5,0,0,1,2.124,0l5.445,5.44A.77.77,0,0,0,12,7.866L6.56,2.426a3.042,3.042,0,0,0-4.3,0h0a3.085,3.085,0,0,0,0,4.366L9.2,13.73a.77.77,0,1,0,1.089-1.089Z",
    transform: "translate(0)",
    fill: "#0000b5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M12.053,13.346,5.326,20.067a2.033,2.033,0,0,0-2.3.4L1.675,21.822a.77.77,0,0,0,0,1.089L3.46,24.7a.77.77,0,0,0,1.088,0L5.9,23.343A2.029,2.029,0,0,0,6.37,21.2l6.772-6.766,1.079,1.078a.77.77,0,0,0,1.088,0l8.277-8.269a3.062,3.062,0,0,0,0-4.333h0a3.067,3.067,0,0,0-4.334,0l-8.277,8.27a.77.77,0,0,0,0,1.089Z",
    transform: "translate(-0.059 -0.293)",
    fill: "#0000b5",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEquipments);
export default __webpack_public_path__ + "static/media/icon-equipments.659d526d39e2793894c5bde044ee0667.svg";
export { ForwardRef as ReactComponent };